export const HBTurq = "#6EFAFF";